<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed } from 'vue'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    active: {
        type: Boolean as PropType<boolean | null>,
        default: null
    }
})

const isActive = computed(() => {
    return typeof props.active === 'boolean'
        ? props.active
        : props.editor.isActive('orderedList')
})

const onToggleOrderedList = () => {
    betaStore.getTextEditorCommandChain(props.editor)?.toggleOrderedList().run()
}
</script>

<template>
    <button
        @click="onToggleOrderedList"
        :class="
            clsx(
                'action-ordered-list',
                isActive ? 'is-active' : 'is-deactive',
                isDark ? 'dark' : 'light'
            )
        "
        :disabled="!editor.can().chain().focus().toggleOrderedList().run()"
    >
        <span class="sr-only">Ordered List</span>

        <svg
            class="w-[25px] h-6"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M11.8573 6.74999H21M11.8573 12.4377H21M12.0263 18.1252H21M5 15.5C5 15.0359 5.17838 14.5908 5.49589 14.2626C5.81341 13.9344 6.24405 13.75 6.69309 13.75C7.14212 13.75 7.57277 13.9344 7.89028 14.2626C8.2078 14.5908 8.38617 15.0359 8.38617 15.5C8.38617 16.0171 7.9629 16.375 7.53963 16.8125L5 19H8.38617M6.69309 10.25V5L5 6.75"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-ordered-list.light svg {
    @apply stroke-[#060606];
}

.action-ordered-list.dark svg {
    @apply stroke-[#FAFAFA];
}

.action-ordered-list.is-deactive svg {
    @apply opacity-60;
}

.action-ordered-list.is-active svg {
    @apply opacity-100;
}
</style>
